import React from 'react';
import { colors } from '@styleseat/brand';

type BasicCircleStarIconProps = {
  width?: number;
  height?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const BasicCircleStarIcon = ({
  width = 24,
  height = 24,
  viewBox = '0 0 24 24',
  color = colors.blackInBlack,
}: BasicCircleStarIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM7.5817 17.9386L8.42552 13.0187L4.85104 9.53448L9.79085 8.81668L12 4.34045L14.2092 8.81668L19.149 9.53448L15.5745 13.0187L16.4183 17.9386L12 15.6157L7.5817 17.9386ZM13.4255 12.3205L13.762 14.2826L12 13.3562L10.238 14.2826L10.5745 12.3205L9.14896 10.931L11.119 10.6447L12 8.85956L12.881 10.6447L14.851 10.931L13.4255 12.3205Z"
      fill={color}
    />
  </svg>
);
